import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';  // ← add this
import { ClipboardModule } from 'ngx-clipboard';
import { ThresholdDialogComponent } from './threshold-dialog-component';

@NgModule({
  declarations: [
    ThresholdDialogComponent
  ],
  exports: [
    ThresholdDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    ClipboardModule
  ]
})
export class ThresholdDialogModule { }